<template>
   <b-breadcrumb v-show="breadCrumbItems.length" :items="breadCrumbItems" />
</template>

<script>
export default {
   computed: {
      breadCrumbItems() {
         const metaCrumbs = this.$route.meta?.breadCrumb || [];

         const company = this.$store.state.companies.currentCompany;
         const companyId = company?.id;
         const companyName = company?.companyName || 'Company';

         return metaCrumbs.map((item) => {
            let newItem = {...item};

            if (newItem.text === '__COMPANYNAME__') {
               newItem.text = companyName;
               newItem.disabled = this.shouldDisable(companyName);
            }

            if (newItem.to?.params) {
               const newParams = {...newItem.to.params};
               Object.keys(newParams).forEach((key) => {
                  newParams[key] = companyId;
               });
               newItem.to.params = newParams;
            }

            return newItem;
         });
      },
   },
   methods: {
      shouldDisable(text) {
         return text === '__SYSTEM__';
      },
   },
};
</script>

<style>
.breadcrumb-item:has(.disabled) {
   display: none;
}
</style>
